/**
 * It should take into account the base url and route type
 */
const baseResetUrl = () => `${window.location.protocol}//${window.location.host}/reset/`;

export { baseResetUrl };
